'use strict';

var UserSummaryPanelController = function UserSummaryPanelController($scope, userSummaryBoxService) {
  $scope.noPendingUsers = false;
  function initUsers() {
    userSummaryBoxService.getUserNumbers().then(function (userSummary) {
      $scope.getActiveUsers = userSummary.activeUsers;
      $scope.getInactiveUsers = userSummary.pendingAccessRequests;
      if ($scope.getInactiveUsers === 0) {
        $scope.noPendingUsers = true;
      }
      $scope.getAvailiableUserAccounts = userSummary.availableUserAccounts;
    });
  }
  $scope.changeScreen = function (destScreen) {
    $scope.$emit('user-management-manage-users:change-screen', destScreen);
  };
  initUsers();
};
UserSummaryPanelController.$inject = ['$scope', 'UserSummaryPanelService'];
module.exports = UserSummaryPanelController;